import * as React from "react";
const IconCFisOos = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" id="FISUnavailable">
    <circle
      cx="7"
      cy="7"
      r="7"
      fill="#A92F31"
      // style="fill:#A92F31;fill:color(display-p3 0.6625 0.1849 0.1935);fill-opacity:1;"
    ></circle>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 4.31541L4.31541 10L4 9.68459L9.68459 4L10 4.31541Z"
      fill="white"
      // style="fill:white;fill-opacity:1;"
    ></path>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.31541 4L10 9.68459L9.68459 10L4 4.31541L4.31541 4Z"
      fill="white"
      // style="fill:white;fill-opacity:1;"
    ></path>
  </svg>
);
export default IconCFisOos;
